<script lang="ts">
    import { _ } from "svelte-i18n";
    export let trainingAdvice;
    export let hideSecondParagraph = false;
    let show_bad_data_view = true;

    let program_type;
    $: if(trainingAdvice != null) refreshContent(trainingAdvice);

    let show_first_paragraph = false;
    let first_display_text = "";
    let phase = "";

    let show_second_paragraph = false;
    let training_gradient_text = "";
    let training_status_text = "";
    let recommended_athlete_text = "";
    let difficulty_text = "";
    let second_display_text = "";
    let xss_goal_text = "";
    
    let show_third_paragraph = false;
    let third_display_text = "";
    let warningText: string;

    export function refreshContent(trainingAdvice){
        if (trainingAdvice.xss_deficit == null) {
            show_first_paragraph = false;
            show_second_paragraph = false;
            return;
        }
        program_type = trainingAdvice.program.type;

        show_first_paragraph = true;

        if (trainingAdvice.recovery_needed) {
            warningText = '<br><br><i class="fa fa-warning"></i> Given you have a large training deficit, <strong>' + trainingAdvice.training_grad_val.text + 
            '</strong> improvement rate and <strong>' + trainingAdvice.form_cat + '</strong> status, you may want to temporarily reduce your improvement goals and consider <i>additional recovery days</i> until freshness returns.';
        } else if (trainingAdvice.max_ramp_rate < trainingAdvice.ir) {
            warningText = '<br><br><i class="fa fa-warning"></i> Your improvement rate is not sustainable. You should plan an easier recovery period every <strong>' + trainingAdvice.weeks_at_max.toFixed(1) + 
            ' weeks.</strong>';
        }
        else {
             warningText = '';
        }

        if (trainingAdvice.xss_deficit > 0) {
            first_display_text = '<a href="https://baronbiosys.com/glossary/training-deficits-and-surpluses" target="_help"><strong>Training Deficit</strong></a> of <strong>' +
                Math.round(trainingAdvice.xss_deficit) +' <a href="https://baronbiosys.com/glossary/XSS"target="_help">XSS</a> points</strong>. Improving at this rate will require about <strong>' + 
                Math.round(trainingAdvice.weekly_hours*10)/10 + ' training hours</strong> this coming week based on your recent training history.';
        } else {
            first_display_text = '<a href="https://baronbiosys.com/glossary/training-deficits-and-surpluses" target="_help"><strong>Training Surplus</strong></a> <strong>of ' + 
                -Math.round(trainingAdvice.xss_deficit) + ' <a href="https://baronbiosys.com/glossary/XSS"target="_help">XSS</a> points</strong>. Continue to maintain consistency in your training.';
        }
        training_status_text = trainingAdvice.form_cat;
        recommended_athlete_text = trainingAdvice.recommended_athlete;
        difficulty_text = trainingAdvice.difficulty_rating;
        xss_goal_text = trainingAdvice.xss_goal.toFixed(0) +" XSS"
        show_second_paragraph = true;

        phase = trainingAdvice.phase;

        training_gradient_text = trainingAdvice.training_grad_val.text

        if (trainingAdvice.recommended_athlete && !trainingAdvice.recovery_needed && trainingAdvice.recommended_athlete != "Recovery") {
            show_first_paragraph = true;
            if (trainingAdvice.xss_deficit >= trainingAdvice.xss_goal) {
                third_display_text = 'The amount of XSS is based on recent activities you performed on <strong>'+trainingAdvice.based_on_day+'</strong> and may include some additional XSS needed to help you get back on track.';
            } else {
                third_display_text = 'The amount of XSS is based on recent activities you performed on <strong>'+trainingAdvice.based_on_day+'</strong> and will help you move towards a training surplus.'
            } 
        } else show_first_paragraph = false
    }
</script>


{#if show_bad_data_view }
<p class="bad-data-view hidden"></p>
{/if}

{#if show_first_paragraph}
<p class="sentence first-paragraph m-0">
    You are in the 

    {#if program_type == "continuous"}
    <strong>Continuous Improvement </strong>
    {:else if program_type == "challenge" }
    <strong>30 Day Challenge </strong>
    {:else}
    <a href="https://baronbiosys.com/glossary/program-phases/" target='_help'><strong>{phase}</strong></a> phase of your 
    {/if}

    program and have chosen a

    <strong>{training_gradient_text}</strong>
    weekly <a href="https://baronbiosys.com/glossary/improvement-rate" target="_help"><strong>improvement rate</strong></a>. You have a 
    <span>{@html first_display_text}</span>
</p>
{/if}


{#if !hideSecondParagraph}
  {#if show_second_paragraph && trainingAdvice.daily_goal_complete =='some' && !trainingAdvice.recovery_needed && !(trainingAdvice.form_cat == "Very tired")}
  <span class="sentence second-paragraph ">
      Your <strong><a href="https://baronbiosys.com/glossary/training-status-and-form/" target="_help">Training Status</a></strong> is <strong>{training_status_text}</strong> and have some training still left to complete. You should consider a  
      <strong><a href="https://baronbiosys.com/glossary/focus"><span>{recommended_athlete_text}</span></a></strong> workout or activity generating
      about <strong>{xss_goal_text}</strong> of overall strain, with less than <span>{difficulty_text}</span> difficulty.
      <span>{@html warningText}</span>
  </span>
  {:else if show_second_paragraph  && trainingAdvice.form_cat == "Very tired"}
  <span class="sentence second-paragraph ">
      Your <strong><a href="https://baronbiosys.com/glossary/training-status-and-form/" target="_help">Training Status</a></strong> is <strong>{training_status_text}</strong> and should consider taking recovery time. 
      Optionally, you may consider an <strong>Active Recovery</strong> workout. 
      <span>{@html warningText}</span>
  </span>
  {:else if trainingAdvice.daily_goal_complete != 'all'}
  <span class="sentence second-paragraph">
      Your <strong><a href="https://baronbiosys.com/glossary/training-status-and-form/" target="_help">Training Status</a></strong> is <strong>{training_status_text}</strong> and {(trainingAdvice.daily_goal_complete == 'all') ? 'could' : 'should'} consider a  
      <strong><a href="https://baronbiosys.com/glossary/focus"><span>{recommended_athlete_text}</span></a></strong> workout or activity generating about <strong>{xss_goal_text}</strong> of overall strain, with less than <span>{difficulty_text}</span> difficulty.
      <span>{@html warningText}</span>
  </span>
  {:else} 
  <span class="sentence third-paragraph ">
      You have no more XSS remaining. 
  </span>
  {/if}
{/if}
